import { isSuccess } from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import head from 'lodash/head'
import { cartSlice } from '@/store/cartSlice'
import { servicesSlice } from '@/store/servicesSlice'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'
import { timeScheduleSlice } from '..'
import { serviceAmountSelector } from './serviceAmountSelector'

export const globalAvailabilitySelector = createSelector(
  [
    timeScheduleSlice.selectors.service,
    servicesSlice.selectors.services,
    cartSlice.selectors.cartReservations,
    serviceAmountSelector,
  ],
  (service, services, reservations, serviceAmount): number => {
    const ticketReservation = head(reservations)

    if (!service || !ticketReservation || !isSuccess(services)) {
      return serviceAmount
    }

    const totalGlobalBoughtQuantity =
      Object.entries(ticketReservation.boughtServices).reduce<number>(
        (acc, entry) => {
          const [key, boughtServices] = entry
          const serviceId = Number(key)

          // skip the selected service, because it's current qty is the `serviceAmount`
          if (serviceId === service.serviceId) {
            return acc
          }

          return acc + getBoughtServicesTotal(boughtServices)
        },
        0
      ) + serviceAmount

    return Math.max(
      0,
      Math.min(
        services.value.availableQuantity - totalGlobalBoughtQuantity,
        (services.value.maximumQuantity > 0
          ? services.value.maximumQuantity
          : Infinity) -
          services.value.reservedQuantity -
          totalGlobalBoughtQuantity
      )
    )
  }
)
